<template>
  <div>
    <Header style="height: 230px; border: none"/>

    <section id="main">
      <OverallResults></OverallResults>

      <PercentageMovement></PercentageMovement>

      <PerCapitaResults></PerCapitaResults>

      <IndividualStateResults></IndividualStateResults>

      <nav id="pages">
        <div class="row clearfix">
          <router-link :to="{name:'Overview'}" class="prev sixcol last">← Introduction &amp; Overview</router-link>
          <router-link :to="{name:'Categories'}" class="next sixcol last">Categories →</router-link>
        </div>
      </nav>
    </section>
  </div>
</template>

<script>

/*eslint-disable */
import OverallResults from './States/OverallResults'
import PercentageMovement from './States/PercentageMovement'
import PerCapitaResults from './States/PerCapitaResults'
import IndividualStateResults from './States/IndividualStateResults'

export default {
  name: 'States',
  components: {
    OverallResults,
    PercentageMovement,
    PerCapitaResults,
    IndividualStateResults,
  },
  data () {
    return {
      scrollPosition: null,
      chartOptionsXXX: {
        chart: {
          map: 'myMapName'
        },

        title: {
          text: 'Highmaps basic demo'
        },

        subtitle: {
          text: 'Source map: <a href="http://code.highcharts.com/mapdata/countries/au/au-all.js">Australia</a>'
        },

        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: 'bottom'
          }
        },

        colorAxis: {
          min: 0
        },

        series: [{
          data: [
            ['au-nt', 0],
            ['au-wa', 1],
            ['au-ct', 2],
            ['au-sa', 3],
            ['au-ql', 4],
            ['au-2557', 5],
            ['au-ts', 6],
            ['au-jb', 7],
            ['au-ns', 8],
            ['au-vi', 9]
          ],
          name: 'Random data',
          states: {
            hover: {
              color: '#BADA55'
            }
          },
          dataLabels: {
            enabled: true,
            format: '{point.name}'
          }
        }]
      },
      chartOptionsXXy: {
        chart: {
          map: 'myMapName'
        },
        title: {
          text: 'Highmaps basic demo'
        },
        subtitle: {
          text:
            'Source map: <a href="http://code.highcharts.com/mapdata/custom/world.js">World, Miller projection, medium resolution</a>'
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            alignTo: 'spacingBox'
          }
        },
        colorAxis: {
          min: 0
        },
        series: [
          {
            name: 'Random data',
            states: {
              hover: {
                color: '#BADA55'
              }
            },
            dataLabels: {
              enabled: true,
              format: '{point.name}'
            },
            allAreas: false,
            data: [
              ['fo', 0],
              ['um', 1],
              ['us', 2],
              ['jp', 3],
              ['sc', 4],
              ['in', 5],
              ['fr', 6],
              ['fm', 7],
              ['cn', 8],
              ['pt', 9],
              ['sw', 10],
              ['sh', 11],
              ['br', 12],
              ['ki', 13],
              ['ph', 14],
              ['mx', 15],
              ['es', 16],
              ['bu', 17],
              ['mv', 18],
              ['sp', 19],
              ['gb', 20],
              ['gr', 21],
              ['as', 22],
              ['dk', 23],
              ['gl', 24],
              ['gu', 25],
              ['mp', 26],
              ['pr', 27],
              ['vi', 28],
              ['ca', 29],
              ['st', 30],
              ['cv', 31],
              ['dm', 32],
              ['nl', 33],
              ['jm', 34],
              ['ws', 35],
              ['om', 36],
              ['vc', 37],
              ['tr', 38],
              ['bd', 39],
              ['lc', 40],
              ['nr', 41],
              ['no', 42],
              ['kn', 43],
              ['bh', 44],
              ['to', 45],
              ['fi', 46],
              ['id', 47],
              ['mu', 48],
              ['se', 49],
              ['tt', 50],
              ['my', 51],
              ['pa', 52],
              ['pw', 53],
              ['tv', 54],
              ['mh', 55],
              ['cl', 56],
              ['th', 57],
              ['gd', 58],
              ['ee', 59],
              ['ag', 60],
              ['tw', 61],
              ['bb', 62],
              ['it', 63],
              ['mt', 64],
              ['vu', 65],
              ['sg', 66],
              ['cy', 67],
              ['lk', 68],
              ['km', 69],
              ['fj', 70],
              ['ru', 71],
              ['va', 72],
              ['sm', 73],
              ['kz', 74],
              ['az', 75],
              ['tj', 76],
              ['ls', 77],
              ['uz', 78],
              ['ma', 79],
              ['co', 80],
              ['tl', 81],
              ['tz', 82],
              ['ar', 83],
              ['sa', 84],
              ['pk', 85],
              ['ye', 86],
              ['ae', 87],
              ['ke', 88],
              ['pe', 89],
              ['do', 90],
              ['ht', 91],
              ['pg', 92],
              ['ao', 93],
              ['kh', 94],
              ['vn', 95],
              ['mz', 96],
              ['cr', 97],
              ['bj', 98],
              ['ng', 99],
              ['ir', 100],
              ['sv', 101],
              ['sl', 102],
              ['gw', 103],
              ['hr', 104],
              ['bz', 105],
              ['za', 106],
              ['cf', 107],
              ['sd', 108],
              ['cd', 109],
              ['kw', 110],
              ['de', 111],
              ['be', 112],
              ['ie', 113],
              ['kp', 114],
              ['kr', 115],
              ['gy', 116],
              ['hn', 117],
              ['mm', 118],
              ['ga', 119],
              ['gq', 120],
              ['ni', 121],
              ['lv', 122],
              ['ug', 123],
              ['mw', 124],
              ['am', 125],
              ['sx', 126],
              ['tm', 127],
              ['zm', 128],
              ['nc', 129],
              ['mr', 130],
              ['dz', 131],
              ['lt', 132],
              ['et', 133],
              ['er', 134],
              ['gh', 135],
              ['si', 136],
              ['gt', 137],
              ['ba', 138],
              ['jo', 139],
              ['sy', 140],
              ['mc', 141],
              ['al', 142],
              ['uy', 143],
              ['cn', 144],
              ['mn', 145],
              ['rw', 146],
              ['so', 147],
              ['bo', 148],
              ['cm', 149],
              ['cg', 150],
              ['eh', 151],
              ['rs', 152],
              ['me', 153],
              ['tg', 154],
              ['la', 155],
              ['af', 156],
              ['ua', 157],
              ['sk', 158],
              ['jk', 159],
              ['bg', 160],
              ['qa', 161],
              ['li', 162],
              ['at', 163],
              ['sz', 164],
              ['hu', 165],
              ['ro', 166],
              ['ne', 167],
              ['lu', 168],
              ['ad', 169],
              ['ci', 170],
              ['lr', 171],
              ['bn', 172],
              ['iq', 173],
              ['ge', 174],
              ['gm', 175],
              ['ch', 176],
              ['td', 177],
              ['kv', 178],
              ['lb', 179],
              ['dj', 180],
              ['bi', 181],
              ['sr', 182],
              ['il', 183],
              ['ml', 184],
              ['sn', 185],
              ['gn', 186],
              ['zw', 187],
              ['pl', 188],
              ['mk', 189],
              ['py', 190],
              ['by', 191],
              ['cz', 192],
              ['bf', 193],
              ['na', 194],
              ['ly', 195],
              ['tn', 196],
              ['bt', 197],
              ['md', 198],
              ['ss', 199],
              ['bw', 200],
              ['bs', 201],
              ['nz', 202],
              ['cu', 203],
              ['ec', 204],
              ['au', 205],
              ['ve', 206],
              ['sb', 207],
              ['mg', 208],
              ['is', 209],
              ['eg', 210],
              ['kg', 211],
              ['np', 212]
            ]
          }
        ]
      },
      categoryShare: {
        chart: {
          type: 'pie'
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: {
              enabled: true,
              style: {
                fontWeight: 'bold',
                color: 'white',
                textShadow: '0px 1px 2px black'
              }
            }
          }
        },
        series: [{
          name: 'Revenue Share',
          data: [
            ['Ballet and Dance', 3.2],
            ['Children\'s Family', 2.9],
            ['Circus and Physical Theatre', 1.4],
            ['Classical Music', 4.1],
            ['Comedy', 4.4],
            ['Contemporary Music', 45.2],
            ['Festivals (Contemporary Music)', 6.9],
            ['Festivals (Multi-Category)', 1.3],
            ['Musical Theatre', 20.4],
            ['Opera', 4.4],
            ['Special Events', 0.9],
            ['Theatre', 4.9]
          ],
          size: '68%',
          innerSize: '40%',
          borderColor: 'none',
          borderWidth: 1,
          slicedOffset: 30,
          showInLegend: false,
          dataLabels: {
            color: '#000',
            style: {
              textShadow: 'none'
            },
            formatter: function () {
              if (this.y > 3) {
                return this.y.toFixed(1) + '% '
              }
            },
            distance: -28
          },
          colors: '#f5bcab'
        },
        {
          name: 'Revenue Share',
          data: [
            ['Ballet and Dance', 3.1],
            ['Children\'s Family', 8.3],
            ['Circus and Physical Theatre', 2.1],
            ['Classical Music', 5],
            ['Comedy', 6.5],
            ['Contemporary Music', 38.9],
            ['Festivals (Contemporary Music)', 5.1],
            ['Festivals (Multi-Category)', 0.9],
            ['Musical Theatre', 17.3],
            ['Opera', 3.9],
            ['Special Events', 0.6],
            ['Theatre', 8.3]
          ],
          size: '68%',
          innerSize: '40%',
          borderColor: 'none',
          borderWidth: 1,
          slicedOffset: 30,
          showInLegend: false,
          dataLabels: {
            color: '#000',
            style: {
              textShadow: 'none'
            },
            formatter: function () {
              if (this.y > 3) {
                return this.y.toFixed(1) + '% '
              }
            },
            distance: -28
          },
          colors: '#70cb92'
        }]
      },
      percentageChart: {
        chart: {
          type: 'bar'
        },
        title: {
          text: ''
        },
        yAxis: {
          /*
           max: 100,
           min: -50,
           */
          title: {
            text: 'Percentage Change'
          },
          valueSuffix: '%'

        },
        xAxis: {
          title: {
            text: ''
          },
          categories: [
            'New South Wales',
            'Victoria',
            'Queensland',
            'Western Australia',
            'South Australia',
            'Australian Capital Territory',
            'Tasmania',
            'Northern Territory'
          ],
          labels: {
            style: {
              color: '#fff'
            }
          }
        },
        series: [
          {
            name: 'Change in Revenue',
            data: [
              { y: -14.9 },
              { y: -10.7 },
              { y: 10.8 },
              { y: 1.7 },
              { y: -4.8 },
              { y: 6.9 },
              { y: -37.4 },
              { y: -14.8 }
            ],
            color: 'yellow'
          },
          {
            name: 'Change in Attendance',
            data: [
              { y: -8.5 },
              { y: -8.3 },
              { y: 7.1 },
              { y: 0.2 },
              { y: -14.8 },
              { y: -16.5 },
              { y: -1.7 },
              { y: -19.3 }
            ],
            color: 'blue'
          }
        ],
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        tooltip: {
          shared: true,
          valueSuffix: '%',
          followPointer: true,
          valueDecimals: 1
        }
      },
      mapOptions: {
        chart: {
          map: 'worldMap'
        },
        title: {
          text: 'Highmaps basic demo'
        },
        subtitle: {
          text: 'Source map: <a href="http://code.highcharts.com/mapdata/custom/world.js">World, Miller projection, medium resolution</a>'
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            alignTo: 'spacingBox'
          }
        },
        colorAxis: {
          min: 0
        },
        series: [{
          name: 'Random data',
          states: {
            hover: {
              color: '#BADA55'
            }
          },
          dataLabels: {
            enabled: true,
            format: '{point.name}'
          },
          allAreas: false,
          data: [
            ['fo', 0],
            ['um', 1],
            ['us', 2],
            ['jp', 3],
            ['sc', 4],
            ['in', 5],
            ['fr', 6],
            ['fm', 7],
            ['cn', 8],
            ['pt', 9],
            ['sw', 10],
            ['sh', 11],
            ['br', 12],
            ['ki', 13],
            ['ph', 14],
            ['mx', 15],
            ['es', 16],
            ['bu', 17],
            ['mv', 18],
            ['sp', 19],
            ['gb', 20],
            ['gr', 21],
            ['as', 22],
            ['dk', 23],
            ['gl', 24],
            ['gu', 25],
            ['mp', 26],
            ['pr', 27],
            ['vi', 28],
            ['ca', 29],
            ['st', 30],
            ['cv', 31],
            ['dm', 32],
            ['nl', 33],
            ['jm', 34],
            ['ws', 35],
            ['om', 36],
            ['vc', 37],
            ['tr', 38],
            ['bd', 39],
            ['lc', 40],
            ['nr', 41],
            ['no', 42],
            ['kn', 43],
            ['bh', 44],
            ['to', 45],
            ['fi', 46],
            ['id', 47],
            ['mu', 48],
            ['se', 49],
            ['tt', 50],
            ['my', 51],
            ['pa', 52],
            ['pw', 53],
            ['tv', 54],
            ['mh', 55],
            ['cl', 56],
            ['th', 57],
            ['gd', 58],
            ['ee', 59],
            ['ag', 60],
            ['tw', 61],
            ['bb', 62],
            ['it', 63],
            ['mt', 64],
            ['vu', 65],
            ['sg', 66],
            ['cy', 67],
            ['lk', 68],
            ['km', 69],
            ['fj', 70],
            ['ru', 71],
            ['va', 72],
            ['sm', 73],
            ['kz', 74],
            ['az', 75],
            ['tj', 76],
            ['ls', 77],
            ['uz', 78],
            ['ma', 79],
            ['co', 80],
            ['tl', 81],
            ['tz', 82],
            ['ar', 83],
            ['sa', 84],
            ['pk', 85],
            ['ye', 86],
            ['ae', 87],
            ['ke', 88],
            ['pe', 89],
            ['do', 90],
            ['ht', 91],
            ['pg', 92],
            ['ao', 93],
            ['kh', 94],
            ['vn', 95],
            ['mz', 96],
            ['cr', 97],
            ['bj', 98],
            ['ng', 99],
            ['ir', 100],
            ['sv', 101],
            ['sl', 102],
            ['gw', 103],
            ['hr', 104],
            ['bz', 105],
            ['za', 106],
            ['cf', 107],
            ['sd', 108],
            ['cd', 109],
            ['kw', 110],
            ['de', 111],
            ['be', 112],
            ['ie', 113],
            ['kp', 114],
            ['kr', 115],
            ['gy', 116],
            ['hn', 117],
            ['mm', 118],
            ['ga', 119],
            ['gq', 120],
            ['ni', 121],
            ['lv', 122],
            ['ug', 123],
            ['mw', 124],
            ['am', 125],
            ['sx', 126],
            ['tm', 127],
            ['zm', 128],
            ['nc', 129],
            ['mr', 130],
            ['dz', 131],
            ['lt', 132],
            ['et', 133],
            ['er', 134],
            ['gh', 135],
            ['si', 136],
            ['gt', 137],
            ['ba', 138],
            ['jo', 139],
            ['sy', 140],
            ['mc', 141],
            ['al', 142],
            ['uy', 143],
            ['cnm', 144],
            ['mn', 145],
            ['rw', 146],
            ['so', 147],
            ['bo', 148],
            ['cm', 149],
            ['cg', 150],
            ['eh', 151],
            ['rs', 152],
            ['me', 153],
            ['tg', 154],
            ['la', 155],
            ['af', 156],
            ['ua', 157],
            ['sk', 158],
            ['jk', 159],
            ['bg', 160],
            ['qa', 161],
            ['li', 162],
            ['at', 163],
            ['sz', 164],
            ['hu', 165],
            ['ro', 166],
            ['ne', 167],
            ['lu', 168],
            ['ad', 169],
            ['ci', 170],
            ['lr', 171],
            ['bn', 172],
            ['iq', 173],
            ['ge', 174],
            ['gm', 175],
            ['ch', 176],
            ['td', 177],
            ['kv', 178],
            ['lb', 179],
            ['dj', 180],
            ['bi', 181],
            ['sr', 182],
            ['il', 183],
            ['ml', 184],
            ['sn', 185],
            ['gn', 186],
            ['zw', 187],
            ['pl', 188],
            ['mk', 189],
            ['py', 190],
            ['by', 191],
            ['cz', 192],
            ['bf', 193],
            ['na', 194],
            ['ly', 195],
            ['tn', 196],
            ['bt', 197],
            ['md', 198],
            ['ss', 199],
            ['bw', 200],
            ['bs', 201],
            ['nz', 202],
            ['cu', 203],
            ['ec', 204],
            ['au', 205],
            ['ve', 206],
            ['sb', 207],
            ['mg', 208],
            ['is', 209],
            ['eg', 210],
            ['kg', 211],
            ['np', 212]
          ]
        }]
      }
    }
  },
  methods: {
    mapBubble () {
      console.info(this.$refs.mapBubbleChart)
      this.$refs.mapBubbleChart.Highcharts('Map', {
        title: {
          text: ''
        },
        mapNavigation: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return this.key + '<br />' + this.series.name + ': ' + this.point.value + '% (' + this.point.absolute + ')'
          }
        },
        series: [{
          color: '#e2c655',
          borderWidth: '0',
          enableMouseTracking: false,
          data: this.states,
          // mapData: Highcharts.maps.australia,
          joinBy: 'hc-key'
        }, {
          type: 'mapbubble',
          color: 'yellow',
          enableMouseTracking: true,
          data: this.rev,
          name: 'Revenue',
          // mapData: Highcharts.maps.australia,
          // mapData: Highcharts.maps['australia-revoffset'],
          joinBy: 'hc-key',
          dataLabels: {
            enabled: true,
            style: {
              textShadow: 'none',
              color: '#fff',
              fontSize: '1.3em',
              fontFamily: 'ff-enzo-web'
            },
            formatter: function () {
              return this.point.value + '%'
            }
          }
        }, {
          type: 'mapbubble',
          map: 'country',
          color: 'orange',
          enableMouseTracking: true,
          data: this.att,
          name: 'Attendance',
          // mapData: Highcharts.maps['australia-attoffset'],
          joinBy: ['hc-key'],
          tooltip: {
            pointFormat: '{point.label}<br /> {series.name}: {point.value}%'
          },
          dataLabels: {
            enabled: true,
            style: {
              textShadow: 'none',
              color: '#fff',
              fontSize: '1.3em',
              fontFamily: 'ff-enzo-web'
            },
            formatter: function () {
              return this.point.value + '%'
            }
          }
        }]
      })
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    // this.mapBubble()
    // window.addEventListener('scroll', this.updateScroll());
  },
  created () {
    window.addEventListener('scroll', this.updateScroll);
    // this.mapBubble()
  }
}
</script>

<style scoped>

</style>
